exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MuiAppBar-root {\n  background-color: #292e2d;\n  color: white;\n  margin: 0.25rem;\n  width: calc(100% - 0.5rem); }\n  .MuiAppBar-root button {\n    color: white; }\n", ""]);

// exports
